export default __webpack_public_path__ + "static/media/PROCESSMETHOD_PRINTING_SLS.b753b1f1.png";